module.exports = __webpack_public_path__ + "static/media/gift_icon.7f6a8d34.svg";